import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styles from '../../css/styling.module.css';
import { getActivityReplyImages } from '../../../actions/activities_reply_actions';
import Dropzone from "react-dropzone";
import YouTube from 'react-youtube';
import ReactPlayer from 'react-player';
import SecureLS from 'secure-ls';
import axios from 'axios'
import { BACK_SERVER_URL } from '../../../config/server';
import { Line, Circle } from 'rc-progress';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const Question_With_Video = (props) => {

    const [videoUpload, setVideoUpload] = useState('')
    const [videoPreview, setVideoPreview] = useState(null);
    const pageIndex = props.pageIndex
    const questionIndex = props.questionIndex
    const [uploadProgress, setUploadProgress] = useState(0);
    const [openModal, set_openModal] = useState(false)
    const [video_to_Confirm, set_video_to_confirm] = useState([])
    const toggle = () => set_openModal(!openModal);

    const uploadVideoToSpaces = (uploadUrl, file, setProgress) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.open("PUT", uploadUrl, true);

            // Use the actual MIME type
            xhr.setRequestHeader("Content-Type", file.type || "video/mp4");

            // Upload progress
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    set_openModal(!openModal)
                    const percent = Math.round((event.loaded / event.total) * 100);
                    setProgress(percent);
                }
            };

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject(new Error(`Upload failed with status ${xhr.status}`));
                }
            };

            xhr.onerror = () => reject(new Error("Network error during upload"));

            xhr.send(file);
        });
    }


    // On Video Select
    const onVideoSelect = async (file) => {

        if (file) {

            // Remove Error Message
            document.getElementById(`error-msg-${props.id}`).innerHTML = "";

            // for (let i = 0; i < file.length; i++) {

            //     // File Extension Check
            //     let fileExtension = file[i].name ? file[i].name.split('.').pop() : 'mp4'

            //     if (fileExtension === "mp4") {

            //         const filee = file[i];

            //         let data = {
            //             fileName: filee.name,
            //             fileType: filee.type || "video/mp4",
            //         }
            //         //  console.log('data ->', data)
            //         const response = await axios.post(`${BACK_SERVER_URL}api/replies/presign`, data);
            //         if (response && response.data) {
            //             // 2. Upload DIRECTLY to spaces
            //             await fetch(response.data.url, {
            //                 method: 'PUT',
            //                 headers: { 'Content-Type': 'video/mp4' },
            //                 body: filee,

            //             });
            //         }




            //         const reader = new FileReader();
            //         reader.onload = () => {
            //             setVideoPreview(reader.result);
            //         };
            //         reader.readAsDataURL(filee);


            //         props.allContent.pages[props.pageIndex].questions[props.questionIndex].video = [filee]

            //         props.setContent({ ...props.allContent });
            //         //} 


            //         //  props.allContent.pages[props.pageIndex].questions[props.questionIndex].video = [file[i]]

            //         //props.setContent({ ...props.allContent });

            //     }
            // }

            for (let i = 0; i < file.length; i++) {
                const fileExtension = file[i].name
                    ? file[i].name.split(".").pop().toLowerCase()
                    : "mp4";

                if (fileExtension === "mp4") {

                    // confirmVideoUpload(file[i])


                    const filee = file[i];
                    const data = {
                        fileName: filee.name,
                        fileType: filee.type || "video/mp4",
                        fileDirectory: 'Replies',
                        activityId: params.surveyid || params.ActivityId || params.activityid,
                        userId: params.UserId ? params.UserId : props.userId
                    };

                    const response = await axios.post(
                        `${BACK_SERVER_URL}api/replies/presign`,
                        data
                    );
                    //set_openModal(false)
                    if (response && response.data && response.data.url) {
                        await uploadVideoToSpaces(
                            response.data.url,
                            filee,
                            setUploadProgress
                        );
                    }

                    // Better preview
                    setVideoPreview(URL.createObjectURL(filee));
                    setUploadProgress(0)
                    props.allContent.pages[props.pageIndex].questions[props.questionIndex].video = [response.data && response.data.key ? response.data.key : filee.name];
                    props.setContent({ ...props.allContent });
                }
            }


        }


        else {
            //console.log('else came here')
            document.getElementById(`error-msg-${props.id}`).innerHTML = `
                <div class="my-2">
                    <div class="alert alert-danger mb-0">
                        Invalid file type
                    </div>
                </div>
            `;
        }

    }


    // on Cancel Video
    const onCancelVideo = (index) => {
        props.allContent.pages[props.pageIndex].questions[props.questionIndex].video.splice(index, 1);
        props.setContent({ ...props.allContent });
        setVideoPreview(null)
        setUploadProgress(0)
    }

    // On Comment
    const onComment = (e) => {

        props.allContent.pages[props.pageIndex].questions[props.questionIndex].comment = e.target.value;
        props.setContent({ ...props.allContent });

    }
    const opts = {
        width: '640',
        height: '360',
        playerVars: {
            autoplay: 0
        },
    };
    const params = useParams();
    const userId = params.UserId
    const ls = new SecureLS()


    const dispatch = useDispatch();
    const [localVideoUrls, setLocalVideoUrls] = useState({});
    const [loadingVideoLocal, setLoadingVideoLocal] = useState({});
    const [localImageUrls, setLocalImageUrls] = useState({});

    const loadVideoFile = (filePath) => {
        if (!filePath || localVideoUrls[filePath] || loadingVideoLocal[filePath]) return;

        setLoadingVideoLocal(prev => ({ ...prev, [filePath]: true }));

        dispatch(getActivityReplyImages([filePath]))
            .then((fileRes) => {
                const resolvedContent = fileRes.payload.content;
                const url = resolvedContent[0]?.fileData?.url || filePath;
                setLocalVideoUrls(prev => ({ ...prev, [filePath]: url }));
            })
            .catch(err => console.error('Failed to resolve video file:', err))
            .finally(() => {
                setLoadingVideoLocal(prev => {
                    const updated = { ...prev };
                    delete updated[filePath];
                    return updated;
                });
            });
    };

    const isVideoResolved = (file) => !!localVideoUrls[file];

    const getFileUrl = (file) => {
        if (typeof file === 'string') {
            if (localVideoUrls[file]) return localVideoUrls[file];
            if (localImageUrls[file]) return localImageUrls[file];
            return file;
        }
        return URL.createObjectURL(file);
    };

    const getFileExtension = (file) => {
        if (typeof file === 'string') {
            return file.split('?')[0].split('.').pop().toLowerCase();
        }
        return file.name.split('.').pop().toLowerCase();
    };

    useEffect(() => {
        if (Array.isArray(props.questionFile) && props.questionFile.length > 0) {
            const pathsToResolve = props.questionFile.filter(f => {
                if (typeof f !== 'string' || f === '') return false;
                const ext = f.split('?')[0].split('.').pop().toLowerCase();
                return ext !== 'mp4' && !localImageUrls[f];
            });

            if (pathsToResolve.length > 0) {
                dispatch(getActivityReplyImages(pathsToResolve))
                    .then((fileRes) => {
                        const resolvedContent = fileRes.payload.content;
                        const urlMap = {};
                        pathsToResolve.forEach((path, idx) => {
                            urlMap[path] = resolvedContent[idx]?.fileData?.url || path;
                        });
                        setLocalImageUrls(prev => ({ ...prev, ...urlMap }));
                    })
                    .catch(err => console.error('Failed to resolve image files:', err));
            }
        }
    }, [props.questionFile]);


    const onChangeText = (value) => {

        props.allContent.pages[props.pageIndex].questions[props.questionIndex].answer = (props.textLimit && !Number.isNaN(parseInt(props.textLimit.max))) ? value.substring(0, parseInt(props.textLimit.max)) : value;
        props.setContent({ ...props.allContent });

    }

    const makeLinksOpenInNewTab = (htmlContent) => {
        // Create a DOM element to parse the HTML content
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlContent;

        // Find all anchor tags within the parsed HTML content
        const anchorTags = tempElement.getElementsByTagName('a');

        // Iterate through the anchor tags and set the target attribute to '_blank'
        for (const anchorTag of anchorTags) {
            anchorTag.setAttribute('target', '_blank');
            // You can also set 'rel' attribute to 'noopener noreferrer' for security best practices
            anchorTag.setAttribute('rel', 'noopener noreferrer');
        }

        // Return the modified HTML content
        return tempElement.innerHTML;
    }

    

    const confirmVideoUpload = () => {

        return <Modal isOpen={openModal} toggle={toggle} id={`ImageModal`} className="modal-dialog-centered shadow-none" >
            <ModalHeader className="bg-white" toggle={toggle}>Are you sure you want to upload this video?</ModalHeader>
            <ModalBody className="text-center">

                <video width={300} controls className="img-fluid- border" style={{ maxHeight: 500 }}>
                    <source src={URL.createObjectURL(video_to_Confirm[0])} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => onVideoSelect(video_to_Confirm)}>
                    Yes
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    }



    return (

        <div className="my-3">
            <div className={styles.card_border} style={props.required && !props.isAnswered ? { borderColor: '#d92550' } : {}}>
                <div className={styles.card_border_body + " pt-4 pb-1"}>
                    <p style={{ color: '#666', fontSize: "1rem", fontWeight: '500', whiteSpace: 'pre-wrap' }} className="mb-0">

                        {/* Required check */}
                        {props.required &&
                            <span className="text-danger mr-1">*</span>
                        }

                        {/* Question text */}
                        {props.questionText &&
                            <span style={{ color: '#000', fontSize: '27px', fontWeight: '500' }} className='mb-0' dangerouslySetInnerHTML={{ __html: makeLinksOpenInNewTab(props.questionText) }} />
                        }

                        {/* Question YT video */}
                        {props.questionVideo && (
                            <div>

                                <YouTube videoId={props.questionVideo} opts={opts} className='py-4 text-center'></YouTube>

                            </div>
                        )}

                    </p>


                                        {/* Question Video */}
                                        {
                                            props.questionFile && Array.isArray(props.questionFile) && props.questionFile.length > 0 && (
                                                <div className="mx-3 mt-2 mb-4">
                                                    <div className="pt-3 d-flex flex-wrap" style={{ gap: '16px' }}>
                                                        {props.questionFile.map((file, index) => {
                                                            const ext = getFileExtension(file);
                                                            const isVideoFile = ext === 'mp4';
                                                            const fileUrl = getFileUrl(file);

                                                            return (
                                                                <div key={index} className="position-relative">
                                                                    {isVideoFile ? (
                                                                        isVideoResolved(file) ? (
                                                                            <div style={{ maxWidth: '300px', overflow: 'hidden' }}>
                                                                                <ReactPlayer url={fileUrl} controls width="100%" />
                                                                            </div>
                                                                        ) : (
                                                                            <div style={{
                                                                                width: '200px', height: '140px',
                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                border: '2px dashed #ccc', borderRadius: '10px', backgroundColor: '#f8f9fa'
                                                                            }}>
                                                                                {loadingVideoLocal[file] ? (
                                                                                    <button type="button" className="btn btn-secondary d-flex align-items-center"
                                                                                        style={{ color: 'white', fontSize: '12px', gap: '6px' }} disabled>
                                                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                                                        Downloading...
                                                                                    </button>
                                                                                ) : (
                                                                                    <button type="button" className="btn btn-secondary"
                                                                                        style={{ color: 'white', fontSize: '12px' }}
                                                                                        onClick={() => loadVideoFile(file)}>
                                                                                        Load Video
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <img src={fileUrl} className={`img-fluid border ${styles.banner_image}`}
                                                                            style={{ borderRadius: '10px', maxWidth: '300px' }} alt="img" />
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            )
                                        }


                    <div className="mt-3 mx-3">

                        {/* File Limit and File Size */}
                        <small className="text-danger">
                            Max files Limit: {props.filesLimit ? props.filesLimit : "1"} | Max file Size: {props.filesSize ? props.filesSize : "500"} MB
                        </small>

                        {/* Video Display & Dropzone  */}
                        {props.video && props.video.length > 0 ? (

                            // Video Display
                            <div className="row pt-3">

                                {props.video.map((videoSrc, index) => {
                                    return (
                                        <div key={index} className="position-relative mx-3 mb-3">
                                            <span className="questionVideo_close" style={{ marginLeft: '275px', zIndex: '2' }} onClick={() => onCancelVideo(index)}>&times;</span>

                                            {videoPreview && videoPreview != null &&
                                                <video width={300} controls className="img-fluid- border" style={{ maxHeight: 500 }}>
                                                    <source src={videoPreview} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            }

                                            {/* {isLoading ? (
                                                <b>Loading Video...</b>
                                            ) : qVideo.data ? (
                                                <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
                                                    <ReactPlayer
                                                        url={`data:${qVideo.type};base64,${qVideo.data}`}
                                                        controls
                                                        width='100%'
                                                    />
                                                </div>
                                            ) : (
                                                <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
                                                    {console.log('video type ->', videoUpload.type, 'video data ->', videoUpload.data)}
                                                    <ReactPlayer

                                                        url={`data:${videoUpload.type};base64,${videoUpload.data}`}
                                                        controls
                                                        width='100%'
                                                    />
                                                </div>
                                            )} */}
                                        </div>
                                    )
                                })}

                            </div>

                        ) : (

                            // Video Drop Zone 
                            // < div className="dropzone-wrapper dropzone-wrapper-sm mb-3">
                            //     <Dropzone
                            //         maxFiles={!Number.isNaN(parseInt(props.filesLimit)) ? parseInt(props.filesLimit) : 0}
                            //         maxSize={!Number.isNaN(parseFloat(props.filesSize)) ? (parseFloat(props.filesSize) * 1048576) : (500 * 1048576)}
                            //         multiple={!Number.isNaN(parseInt(props.filesLimit)) ? (parseInt(props.filesLimit) > 0 ? true : false) : false}
                            //         accept={".mp4"}
                            //         onDrop={file => onVideoSelect(file)}

                            //     >

                            //         {({ getRootProps, getInputProps }) => (
                            //             <div {...getRootProps()}>
                            //                 <input {...getInputProps()} />
                            //                 <div className="dropzone-content" style={{ cursor: 'pointer' }}>

                            //                     {videoPreview != null ? (
                            //                         // <video controls style={{ width: '50%', height: '50%' }}>
                            //                         //     <source src={''} type="video/mp4" />
                            //                         //     Your browser does not support the video tag.
                            //                         // </video>
                            //                         <div></div>
                            //                     ) : (

                            //                         <div className="d-flex">
                            //                             <span className="pe-7s-video ml-1 mr-3" style={{ fontSize: "2rem", verticalAlign: "middle" }}></span>
                            //                             <span className="text-left align-self-center" style={{ verticalAlign: "middle" }}>Click to select file to upload.</span>
                            //                         </div>)}

                            //                     {/* <div className="d-flex">
                            //                         <span className="pe-7s-video ml-1 mr-3" style={{ fontSize: "2rem", verticalAlign: "middle" }}></span>
                            //                         <span className="text-left align-self-center" style={{ verticalAlign: "middle" }}>Click to select file to upload.</span>
                            //                     </div> */}
                            //                 </div>

                            //             </div>
                            //         )}
                            //     </Dropzone>
                            //     {uploadProgress ===0  && <div style={{ height: '50%', position: 'relative' }}>
                            //         <Circle
                            //             percent={uploadProgress}
                            //             strokeWidth={4}
                            //             trailWidth={4}
                            //             trailColor='#E5E5E5'
                            //             strokeColor="#47B221"
                            //         />
                            //     </div>}
                            // </div>
                            <div className="dropzone-wrapper dropzone-wrapper-sm mb-3">

                                <Dropzone
                                    maxFiles={!Number.isNaN(parseInt(props.filesLimit))
                                        ? parseInt(props.filesLimit)
                                        : 0}

                                    maxSize={!Number.isNaN(parseFloat(props.filesSize))
                                        ? (parseFloat(props.filesSize) * 1048576)
                                        : (500 * 1048576)}

                                    multiple={!Number.isNaN(parseInt(props.filesLimit))
                                        ? (parseInt(props.filesLimit) > 0 ? true : false)
                                        : false}

                                    accept={".mp4"}

                                    onDrop={(file) => {
                                       
                                        set_openModal(true)
                                        set_video_to_confirm(file)
                                          
                                    }}
                                >

                                    {({ getRootProps, getInputProps }) => (

                                        <div {...getRootProps()}>

                                            <input {...getInputProps()} />

                                            <div
                                                className="dropzone-content"
                                                style={{
                                                    cursor: 'pointer',
                                                    minHeight: '140px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}
                                            >

                                                {/* SHOW PROGRESS */}
                                                {uploadProgress > 0 ? (

                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                width: '90px',
                                                                height: '90px',
                                                                position: 'relative'
                                                            }}
                                                        >
                                                            <Circle
                                                                percent={uploadProgress}
                                                                strokeWidth={10}
                                                                trailWidth={10}
                                                                trailColor='#E5E5E5'
                                                                strokeColor="#47B221"
                                                            />
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginTop: '10px',
                                                                fontWeight: '600',
                                                                fontSize: '15px'
                                                            }}
                                                        >
                                                            Uploading... {uploadProgress}%
                                                        </div>

                                                    </div>

                                                ) : (

                                                    /* DEFAULT CONTENT */

                                                    <div className="d-flex">

                                                        <span
                                                            className="pe-7s-video ml-1 mr-3"
                                                            style={{
                                                                fontSize: "2rem",
                                                                verticalAlign: "middle"
                                                            }}
                                                        />

                                                        <span
                                                            className="text-left align-self-center"
                                                            style={{
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            Click to select file to upload.
                                                        </span>

                                                    </div>

                                                )}

                                            </div>

                                        </div>

                                    )}

                                </Dropzone>

                            </div>

                        )}

                        {/* Text  Area */}
                        {/* <textarea id={props.id} className="form-control" placeholder="Write description here" value={props.answer} onChange={e => onChangeText(e.target.value)} /> */}

                        {openModal && confirmVideoUpload()}
                        {/* Comment */}
                        {props.isComment && (
                            <div className="form-group mt-1 mb-3">
                                <label>Comment</label>
                                <input className="form-control" type="text" value={props.comment} onChange={onComment} placeholder="Write here" />
                            </div>
                        )}

                    </div>

                    {/* Upload related error */}
                    <div id={`error-msg-${props.id}`}></div>

                    {/* Required Answer error */}
                    {/* {props.required && !props.isAnswered && (
                        <div id={`error-msg`}>
                            <div className="my-2">
                                <div className="alert alert-danger mb-0">
                                    Please answer this question.
                                </div>
                            </div>
                        </div>
                    )} */}


                </div>
            </div>
        </div >
    )

}

export default Question_With_Video;